import {nanoid} from 'nanoid';
import {LogId} from '../ApiStore';

export default () => nanoid() as LogId;
